import { useCallback, useEffect, useState } from 'react';
import {
  readStoredView,
  writeStoredView,
  VIEWS,
  type SignaView,
} from '../lib/view';

/**
 * Owns the active top-level view. Persists to localStorage and wires
 * Cmd/Ctrl+1 through Cmd/Ctrl+6 to switch between Today / Inbox / Archive / Todos / Notes / Memory.
 */
export function useView() {
  const [view, setViewState] = useState<SignaView>(() => readStoredView());

  const setView = useCallback((next: SignaView) => {
    writeStoredView(next);
    setViewState(next);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey)) return;
      if (e.shiftKey || e.altKey) return;
      const idx = ['1', '2', '3', '4', '5', '6'].indexOf(e.key);
      if (idx < 0) return;
      const target = e.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable)
      ) {
        return;
      }
      const next = VIEWS[idx]?.id;
      if (next) {
        e.preventDefault();
        setView(next);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setView]);

  return { view, setView };
}
